import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import CheckBox from 'Components/common/CheckBoxNew';
import advSearchState from 'Stores/advSearch';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import ToolTipWithIcon from 'Components/common/ToolTipWithIcon';
import DeliverablityTooltip from 'Components/common/DeliverabilityTooltip';
import { Utils } from 'Utils/utils';

const EmailPreference = observer(props => {
  const { filterInPage = false } = props;
  const errorMessage = useRef();

  let currentSelectedState;

  if (filterInPage) currentSelectedState = advSearchState;
  else currentSelectedState = advSearchFilterPopupState;

  let checkBoxFilters;
  if (filterInPage) checkBoxFilters = advSearchState.checkBoxFilters;
  else checkBoxFilters = advSearchFilterPopupState.checkBoxFilters;

  let ecsPercentage;
  if (filterInPage) ecsPercentage = advSearchState.ecsPercentage;
  else ecsPercentage = advSearchFilterPopupState.ecsPercentage;

  const onInputChange = (e, val) => {
    if (filterInPage) {
      advSearchState.resetPageNumberToDefaultValue();
      advSearchState.setEmailDeliverability(val);
    } else {
      advSearchFilterPopupState.setEmailDeliverability(val);
    }
  };

  return (
    <div
      className="input-section email-deliver"
      onClick={e => e.stopPropagation()}
    >
      {Utils.isCreditBasedSubscription() && (
        <>
          <CheckBox
            label="Available"
            onClick={() => {
              advSearchState.saveEmailSearchPreferenceToAPI({
                showContactsWithEmail: !currentSelectedState.checkBoxFilters
                  .showContactsWithEmail,
                showContactsWithoutEmail:
                  currentSelectedState.checkBoxFilters.showContactsWithoutEmail,
              });
              if (
                currentSelectedState.checkBoxFilters.showContactsWithEmail &&
                !currentSelectedState.checkBoxFilters.showContactsWithoutEmail
              ) {
                if (errorMessage.current)
                  errorMessage.current.style.visibility = 'visible';
                setTimeout(() => {
                  if (errorMessage.current)
                    errorMessage.current.style.visibility = 'hidden';
                }, 3000);
              } else if (filterInPage) {
                advSearchState.resetPageNumberToDefaultValue();
                advSearchState.setCheckBoxFilters('showContactsWithEmail');
              } else {
                advSearchFilterPopupState.setCheckBoxFilters(
                  'showContactsWithEmail',
                );
              }
            }}
            isChecked={checkBoxFilters.showContactsWithEmail}
          />
          <div className="check-box-wrap">
            <CheckBox
              label="Not available"
              onClick={() => {
                advSearchState.saveEmailSearchPreferenceToAPI({
                  showContactsWithEmail:
                    currentSelectedState.checkBoxFilters.showContactsWithEmail,
                  showContactsWithoutEmail: !currentSelectedState
                    .checkBoxFilters.showContactsWithoutEmail,
                });
                if (
                  !currentSelectedState.checkBoxFilters.showContactsWithEmail &&
                  currentSelectedState.checkBoxFilters.showContactsWithoutEmail
                ) {
                  if (errorMessage.current)
                    errorMessage.current.style.visibility = 'visible';
                  setTimeout(() => {
                    if (errorMessage.current)
                      errorMessage.current.style.visibility = 'hidden';
                  }, 3000);
                } else if (filterInPage) {
                  advSearchState.resetPageNumberToDefaultValue();
                  advSearchState.setCheckBoxFilters('showContactsWithoutEmail');
                } else {
                  advSearchFilterPopupState.setCheckBoxFilters(
                    'showContactsWithoutEmail',
                  );
                }
              }}
              isChecked={checkBoxFilters.showContactsWithoutEmail}
            />
            <ToolTipWithIcon>
              Contact includes Name, Title, Company and Linkedin URL.
            </ToolTipWithIcon>
            <div className="error-message" ref={errorMessage}>
              <sup>*</sup>Atleast one option must be selected
            </div>
          </div>
        </>
      )}
      <div className="email-deliver-header">
        Email Deliverability
        <DeliverablityTooltip />
      </div>
      <div className="tabs-wrapper">
        <div
          className={`tab${ecsPercentage === '*' ? ' selected' : ''}`}
          onClick={e => onInputChange(e, '*')}
        >
          {'>75%'}
        </div>
        <div
          className={`tab${ecsPercentage === '81' ? ' selected' : ''}`}
          onClick={e => onInputChange(e, '81')}
        >
          {'>85%'}
        </div>
        <div
          className={`tab${ecsPercentage === '91' ? ' selected' : ''}`}
          onClick={e => onInputChange(e, '91')}
        >
          {'>95%'}
        </div>
      </div>
      <div className="note">
        <sup>*</sup>Applies only to contacts with email
      </div>
    </div>
  );
});

export { EmailPreference };
export default EmailPreference;
